module.exports = __webpack_public_path__ + "img/cp5_02.26b886e5.jpg";